import {
    addDoc,
    getDocs,
    collection,
    doc,
    updateDoc,
    getCountFromServer,
    query,
    deleteDoc
} from 'firebase/firestore'
import { db } from '../firebase'
export default class Subscription {
    constructor() {
        this.KEY = 'Subscription'
    }
    async allSubscriptions() {
        let data = []
        try {
            const querySnapshot = await getDocs(collection(db, this.KEY));

            querySnapshot.forEach((doc) => {
                // console.log(doc.id, " => ", doc.data());
                data.push({ ...doc.data(), id: doc.id })
            });
            return data
        } catch (error) {
            console.log(error);
            return []
        }
    }
    async addSubscription(params) {
        try {
            if (params.id) {
                const { id, ...prms } = params
                const docRef = doc(db, this.KEY, id)
                return await updateDoc(docRef, prms)
            }
            const coll = collection(db, this.KEY);
            const snapshot = await (await getCountFromServer(query(coll))).data().count;
            return await (await addDoc(collection(db, this.KEY), { ...params, id: snapshot })).id
        } catch (error) {
            console.error(error, params);
        }
    }
    async deleteSubscription(id) {
        try {
            const docRef = doc(db, this.KEY, id)
            return await deleteDoc(docRef)
        } catch (error) {
            console.error(error, id)
        }
    }
}